import { path, httpService } from '@commons';

/////////////////////////////////////////////////////////////////////////////////
const args = { ...path, path: '/veiculo' };
/////////////////////////////////////////////////////////////////////////////////

export function createVeiculoCadastro(payload) {
  return httpService.post(args, payload);
}

export function updateVeiculoCadastro(payload) {
  const { id } = payload

  return httpService.put({ ...args, args: `/${id}` }, payload);
}

export function listVeiculoCadastro(param) {
  return httpService.get({...args, args: param});
}

export function findVeiculoCadastro(id) {
  return httpService.get({ ...args, args: `/${id}` });
}

export function findAllVeiculoCadastro() {
  return httpService.get({ ...args, path: '/veiculo/all' });
}

export function deleteVeiculoCadastro(id) {
  return httpService.del({ ...args, args: `/${id}` });
}

